var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"juicer-container"},[_c('h1',[_vm._v("JOIN ME ON INSTAGRAM")]),_vm._v(" "),_c('div',{staticClass:"box-row"},[_c('iframe',{staticStyle:{"display":"block","margin":"0 auto"},attrs:{"src":"https://www.juicer.io/api/feeds/jackieserviss/iframe?per=8+gutter=10","frameborder":"0","width":"100%","height":"720"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd501258","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Juicer.vue
// module id = 227
// module chunks = 0